<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";
import {Plus} from "@lucide/vue";
import {Dialog, DialogTrigger} from "@/core/components/ui/dialog";
import {ref} from "vue";
import useSwr from "@/core/composables/swr/useSwr";
import {cacheKey} from "@/lib/cache";
import {contestApi} from "@/container";
import {ContestTemplate} from "@/contest/interfaces";
import ContestForm from "@/contest/components/ContestForm.vue";

const emits = defineEmits(['on-refresh']);

const modalOpen = ref(false);
const template = ref<ContestTemplate>();

const {data: templates} = useSwr(() => cacheKey("/contests/templates"), () => contestApi().templates());

/**
 * Prefill the form with template information, then display the modal with the prefilled elements.
 *
 * @param value
 */
const createWithTemplate = (value: ContestTemplate) => {
    template.value = value;

    modalOpen.value = true;
};

</script>

<template>
  <div class="flex flex-col gap-y-4">
    <div class="flex flex-row items-start justify-between p-4 gap-6">
      <div class="flex flex-col gap-y-1">
        <h2 class="font-bold">
          Animez votre équipe avec vos propres challenges.
        </h2>
        <span>Choisissez un modèle ou créez votre challenge en sélectionnant vos produits</span>
      </div>
      <Dialog v-model:open="modalOpen">
        <DialogTrigger>
          <BaseButton primary density="comfortable">
            <Plus class="w-5 h-5 mr-1" />
            Créer un challenge
          </BaseButton>
        </DialogTrigger>
        <ContestForm
          :edit="false"
          :template="template"
          :open-state="modalOpen"
          @on-refresh="emits('on-refresh')"
          @update:open="modalOpen = $event"
        />
      </Dialog>
    </div>
    <div class="grid grid-cols-3 lg:grid-cols-5 gap-10">
      <div
        v-for="template in (templates ?? [])"
        :key="template.id"
        class="bg-white rounded-lg p-4 shadow w-52 flex flex-col items-center justify-center"
      >
        <img v-if="template.file?.url" :src="template.file.url" class="h-32 w-32 object-contain" alt="Image contest">
        {{ template.name }}
        <div class="flex flex-row w-full justify-end items-end pt-2">
          <BaseButton primary density="comfortable" @click="createWithTemplate(template)">
            <Plus class="w-5 h-5" />
          </BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
